import { render, staticRenderFns } from "./DashboardHero12MonthsVoiceUsage.vue?vue&type=template&id=25628fbe&"
import script from "./DashboardHero12MonthsVoiceUsage.vue?vue&type=script&lang=js&"
export * from "./DashboardHero12MonthsVoiceUsage.vue?vue&type=script&lang=js&"
import style0 from "./DashboardHero12MonthsVoiceUsage.vue?vue&type=style&index=0&id=25628fbe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports